(() => {
  'use strict';

  const LIMITED_VARIANTS = new Set([
    '52962154545333', // HYPD Sachet - Chocolate
    '52962154578101'  // HYPD Sachet - Unflavoured
  ]);
  const LIMIT = 1;
  const MESSAGE = 'You can add only 1 sachet of each flavour per order.';
  const rootUrl = () => window.Shopify?.routes?.root || '/';

  function isLimitedVariant(value) {
    return LIMITED_VARIANTS.has(String(value || ''));
  }

  function getVariantIdFromForm(form) {
    return form?.querySelector('[name="id"]')?.value || '';
  }

  function setFormMessage(form, message) {
    const errorBox = form?.querySelector('.product-form__error-message');
    if (!errorBox) return;
    errorBox.hidden = !message;
    errorBox.textContent = message || '';
  }

  function showNotice(message = MESSAGE) {
    document.getElementById('hypd-sachet-limit-toast')?.remove();

    const toast = document.createElement('div');
    toast.id = 'hypd-sachet-limit-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    toast.style.cssText = [
      'position:fixed',
      'left:50%',
      'bottom:24px',
      'transform:translateX(-50%) translateY(12px)',
      'z-index:999999',
      'max-width:min(420px,calc(100vw - 32px))',
      'padding:11px 15px',
      'border:1px solid rgba(31,31,31,.12)',
      'border-radius:10px',
      'background:#fff',
      'color:#1f1f1f',
      'box-shadow:0 10px 30px rgba(0,0,0,.12)',
      'font-size:13px',
      'font-weight:600',
      'line-height:1.4',
      'text-align:center',
      'opacity:0',
      'transition:opacity .2s ease,transform .2s ease'
    ].join(';');

    document.body.appendChild(toast);
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });

    window.setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(8px)';
      window.setTimeout(() => toast.remove(), 220);
    }, 2800);
  }

  function applyQuantityLimit(scope = document) {
    scope.querySelectorAll?.('[data-quantity-variant-id]').forEach((input) => {
      if (!isLimitedVariant(input.dataset.quantityVariantId)) return;

      input.setAttribute('max', String(LIMIT));
      input.setAttribute('data-max', String(LIMIT));

      if (Number(input.value || LIMIT) > LIMIT) {
        input.value = String(LIMIT);
      }

      const quantityInput = input.closest('quantity-input');
      const plusButton = quantityInput?.querySelector('button[name="plus"]');
      if (plusButton) {
        plusButton.disabled = Number(input.value || LIMIT) >= LIMIT;
        plusButton.setAttribute('aria-disabled', plusButton.disabled ? 'true' : 'false');
      }
    });
  }

  async function getCart() {
    const response = await fetch(`${rootUrl()}cart.js`, {
      method: 'GET',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to check cart quantity.');
    return response.json();
  }

  function quantityInCart(cart, variantId) {
    return (cart?.items || []).reduce((total, item) => {
      return String(item.variant_id) === String(variantId)
        ? total + Number(item.quantity || 0)
        : total;
    }, 0);
  }

  async function normalizeExistingCart() {
    try {
      const cart = await getCart();
      const limitedLines = (cart.items || []).filter(
        (item) => isLimitedVariant(item.variant_id) && Number(item.quantity) > LIMIT
      );

      if (!limitedLines.length) return;

      for (const line of limitedLines) {
        const response = await fetch(`${rootUrl()}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: line.key, quantity: LIMIT })
        });

        if (!response.ok) throw new Error('Unable to correct HYPD sachet quantity.');
      }

      showNotice();

      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: false }
        }));
      }
    } catch (error) {
      console.error('[HYPD Sachet Limit]', error);
    }
  }

  // Stop duplicate add-to-cart attempts before the theme submits them.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const variantId = getVariantIdFromForm(form);
    if (!isLimitedVariant(variantId)) return;

    const quantityField = form.querySelector('[name="quantity"]') ||
      document.querySelector(`[name="quantity"][form="${CSS.escape(form.id || '')}"]`);

    if (quantityField) quantityField.value = String(LIMIT);

    if (form.dataset.hypdLimitBypass === 'true') {
      delete form.dataset.hypdLimitBypass;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    setFormMessage(form, '');

    const submitter = event.submitter;
    if (submitter) submitter.setAttribute('aria-busy', 'true');

    try {
      const cart = await getCart();

      if (quantityInCart(cart, variantId) >= LIMIT) {
        setFormMessage(form, MESSAGE);
        showNotice();
        return;
      }

      form.dataset.hypdLimitBypass = 'true';
      if (submitter && typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter);
      } else if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    } catch (error) {
      console.error('[HYPD Sachet Limit]', error);
      setFormMessage(form, 'Please try again.');
    } finally {
      if (submitter) submitter.removeAttribute('aria-busy');
    }
  }, true);

  // Block + buttons and typed quantities above 1 anywhere in the theme.
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('button[name="plus"]');
    if (!button) return;

    const input = button.closest('quantity-input')?.querySelector('[data-quantity-variant-id]');
    if (!input || !isLimitedVariant(input.dataset.quantityVariantId)) return;

    if (Number(input.value || LIMIT) >= LIMIT) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = String(LIMIT);
      showNotice();
    }
  }, true);

  const clampInput = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!isLimitedVariant(input.dataset.quantityVariantId)) return;

    if (Number(input.value || 0) > LIMIT) {
      input.value = String(LIMIT);
      showNotice();
    }
    applyQuantityLimit(input.closest('quantity-input') || document);
  };

  document.addEventListener('input', clampInput, true);
  document.addEventListener('change', clampInput, true);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) applyQuantityLimit(node);
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    applyQuantityLimit(document);
    normalizeExistingCart();
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
